var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"numbers"},[(_vm.before)?_c('span',[_vm._v(_vm._s(_vm.before))]):_vm._e(),_c('span',{staticClass:"primary"},[_vm._v(_vm._s(_vm.n || '0'))]),(_vm.after)?_c('span',[_vm._v(_vm._s(_vm.after))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }